"use client";

import { useEffect } from "react";

/**
 * Strips native browser `title` tooltips on hover (the white OS popups).
 * Custom tooltips (BastionTooltip, stock preview cards, etc.) are unaffected.
 */
export default function SuppressNativeTitleTooltips() {
  useEffect(() => {
    const strip = (e: Event) => {
      const el = (e.target as Element | null)?.closest?.("[title]") as HTMLElement | null;
      if (el?.title) el.removeAttribute("title");
    };

    document.addEventListener("mouseover", strip, true);
    document.addEventListener("focusin", strip, true);
    return () => {
      document.removeEventListener("mouseover", strip, true);
      document.removeEventListener("focusin", strip, true);
    };
  }, []);

  return null;
}
